import { render, staticRenderFns } from "./NavbarOther.vue?vue&type=template&id=28e9fc32"
import script from "./NavbarOther.vue?vue&type=script&lang=js"
export * from "./NavbarOther.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports